import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'dibs-react-intl';
import serverVars from 'server-vars';
import { localStorage, sessionStorage } from 'dibs-browser-storage';
import {
    GDPR_KEY_AGREED,
    GDPR_KEY_NOT_APPLICABLE,
} from '../components/CookieNotification/constants';
import { shouldDisableNotifications } from '../utils/notificationsHelper';

const getBuyerCookieNotificationClient = ({ node, relayEnv }) => {
    const isLocalSet = !!localStorage.getItem(GDPR_KEY_AGREED);
    const isSessionSet = !!sessionStorage.getItem(GDPR_KEY_NOT_APPLICABLE);

    if (isSessionSet || isLocalSet || shouldDisableNotifications()) {
        return;
    }

    const cookiePromise = import(
        /* webpackChunkName: "cookieNotification" */ '../components/cookieNotification'
    );

    cookiePromise.then(({ cookieNotificationRootQuery, CookieNotificationRenderer }) => {
        const locale = serverVars.get('locale');
        const messages = serverVars.get('messages');
        const root = createRoot(node);
        root.render(
            <IntlProvider locale={locale} messages={messages}>
                <CookieNotificationRenderer
                    environment={relayEnv}
                    query={cookieNotificationRootQuery}
                />
            </IntlProvider>
        );
    });
};

export { getBuyerCookieNotificationClient };
